import { render, staticRenderFns } from "./department_list.vue?vue&type=template&id=c04de27a&scoped=true&"
import script from "./department_list.vue?vue&type=script&lang=js&"
export * from "./department_list.vue?vue&type=script&lang=js&"
import style0 from "./department_list.vue?vue&type=style&index=0&id=c04de27a&lang=less&scoped=true&"
import style1 from "./department_list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04de27a",
  null
  
)

export default component.exports